<div
  [ngClass]="{ hidden: !builder.config.headActions && !hasFiltering() }"
  class="table-top-controls main-toolbar mat-elevation-z2"
>
  <div class="button-controls" *ngIf="builder.config.headActions && builder.config.headActions.length">
    <ng-container *ngFor="let action of builder.config.headActions">
      <button mat-raised-button color="{{ action.color }}"
              [disabled]="action.disabled && action.disabled(action)"
              (click)="action.action()">
        {{ action.name | translate }}
      </button>
    </ng-container>
  </div>
  <div *ngIf="title">
    <div class="table-title">
      {{ title }}
    </div>
  </div>
  <div class="filter-place">
    <div class="table-filter" [ngClass]="{ hidden: !hasFiltering() }">
      <mat-form-field>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput #filter placeholder="{{ 'system.search' | translate }}" [value]="preFilter"/>
        <button mat-button *ngIf="filter.value" matSuffix matTooltip="Clear" (click)="clearFilter()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="date-picker-filter" *ngIf="builder.config.isDatePickerFilter">
      <mee-date-picker
        [dateReturnFormat]="builder.config.datePickerReturnFormat"
        (onChooseNewDate)="onChangeSelectedDate($event)"
      ></mee-date-picker>
    </div>

    <div class="table-switch-deleted" *ngIf="enableDelFiltration">
      <mat-slide-toggle color="primary" (change)="onShowArchived($event)" [checked]="showArchived"
      >{{ 'system.showArchived' | translate }}
      </mat-slide-toggle>
    </div>
  </div>
</div>

<mat-card class="table-place" [ngClass]="{ hidden: !builder.list.length }" [ngStyle]="{ 'min-width': minWidth }">
  <div
    class="categories-wrapper"
    *ngIf="!showArchived"
    [ngStyle]="(!builder.config.categories || builder.config.categories.length === 0) && { height: '0' }"
  >
    <mee-categories
      (refreshListAndCategoriesData)="onRefreshListAndCategoriesData($event)"
      (selectedItemsByCategoryChanged)="selectedItemsByCategoryChanged($event)"
      [list]="builder.list"
      [categories]="builder.config.categories"
    ></mee-categories>
  </div>
  <div class="table-wrapper">
    <div class="table-container" [ngClass]="{ hidden: !builder.list.length }">
      <mat-table #table [dataSource]="dataSource" matSort [matSortActive]="matSortActive" matSortDirection="desc">
        <!-- Columns -->
        <ng-container *ngFor="let col of builder.config.columns" matColumnDef="{{ col.key }}">
          <ng-container *ngIf="!col.sortable">
            <mat-header-cell [ngStyle]="col.style" [ngClass]="col.classes"
                             *matHeaderCellDef>{{ col.title | translate }}
            </mat-header-cell>
          </ng-container>
          <ng-container *ngIf="col.sortable">
            <mat-header-cell [ngStyle]="col.style" [ngClass]="col.classes" *matHeaderCellDef mat-sort-header
            >{{ col.title | translate }}
            </mat-header-cell>
          </ng-container>
          <mat-cell
            [ngStyle]="col.style"
            [ngClass]="col.classes"
            [matTooltip]="getTooltipText(row, col.key)"
            [matTooltipClass]="'tooltip-words-separator'"
            [matTooltipPosition]="getTooltipPosition(col.key)"
            [title]="getScheduleTooltipText(row, col.key)"
            (click)="navigateScheduling($event, row)"
            *matCellDef="let row"
          >
            <mee-table-cell-content
              [column]="col"
              [content]="row[col.key]"
              [param]="row['CompanySlug']"
              [isEventBubblingDisabled]="col.isEventBubblingDisabled"
            ></mee-table-cell-content>
          </mat-cell>
        </ng-container>

        <!-- Action -->
        <ng-container *ngIf="hasActions()" matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="text-right cell-actions">
            <mee-table-action
              *ngFor="let action of builder.config.headActions"
              [icon]="action.icon"
              [actTooltip]="action.tooltip"
              [color]="action.color"
              [visible]="getHeadActionVisible(action)"
              (action)="action.action()"
            ></mee-table-action>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="text-right" width="30%">
            <ng-container *ngIf="builder.config.rowActions">
              <mee-table-action
                *ngFor="let action of builder.config.rowActions"
                [icon]="action.icon"
                [name]="action.name"
                actTooltip="{{ getTooltip(action.tooltip, row) | translate }}"
                [router]="action.router && action.router(row)"
                [color]="action.color"
                [disabled]="action.disabled && action.disabled(row)"
                [visible]="getRowActionVisible(action, row)"
                (action)="confirm($event, action, row, action.action)"
              ></mee-table-action>
            </ng-container>

            <ng-container *ngIf="builder.config.rowGroupActions && builder.config.rowGroupActions.length">
              <button mat-icon-button [matMenuTriggerFor]="menu" (click)="openRowMenuClick($event)">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <ng-container *ngFor="let action of builder.config.rowGroupActions">
                  <button
                    mat-menu-item
                    title="{{ action.name }}"
                    (click)="confirm($event, action, row, action.action)"
                    [disabled]="action.disabled === true || (action.disabled && action.disabled(row))"
                    *ngIf="getRowActionVisible(action, row)"
                  >
                    <mat-icon>{{ action.icon }}</mat-icon>
                    <span>{{ action.name }}</span>
                  </button>
                </ng-container>
              </mat-menu>
            </ng-container>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          [class.deleted]="row.IsArchived || row.IsCascadeArchived"
          [class.clickable]="builder.config.rowClickAction"
          (click)="onRowClick(row)"
        ></mat-row>
      </mat-table>
      <mat-paginator
        #paginator
        [ngClass]="{ hidden: !hasPagination() || !builder.list.length }"
        [length]="dataSource.intermediateDataLength"
        [pageIndex]="0"
        [pageSize]="paginatorOptions.pageSize"
        [pageSizeOptions]="paginatorOptions.pageSizeOptions"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>
</mat-card>

<div class="empty-list-wrapper" *ngIf="!isDataLoading && !builder.list.length && builder.config.emptyListErrorText">
  <div class="empty-list">
    <img src="../../../assets/img/icons/empty-list.png" alt=""/>
    <h1>{{ builder.config.emptyListErrorText | translate | uppercase }}</h1>
  </div>
</div>
